export class SimpleRegisteredEstablishmentExporterInfo {
    ID;
    ExporterName;
    ReviewRequiredPriorToDeptSubmission;
    constructor({id, exporterName, reviewRequiredPriorToDeptSubmission}) {
        this.ID = id;
        this.ExporterName = exporterName;
        this.ReviewRequiredPriorToDeptSubmission = reviewRequiredPriorToDeptSubmission;
    }
}